export default __webpack_public_path__ + "static/media/pa_4.9978a116.mp3";